// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1n4Si","item":"PaymentsMobile_item__kxYIo","label":"PaymentsMobile_label__1xa67","amount":"PaymentsMobile_amount__Al097"};